/**
 * src/util/paginationStorage.js
 *
 * Persists and retrieves the active pagination page index across admin listings.
 * Scoped by route pathname and optional sub-key (such as tab type or status filter).
 * Ensures admins remain on their current page after edits, updates, and navigation.
 */

export const getPaginationKey = (pathname = '', subKey = '') => {
  let path = pathname;
  if (!path && typeof window !== 'undefined' && window.location) {
    path = (window.location.hash || window.location.pathname || '')
      .replace(/^#\/?/, '')
      .split('?')[0];
  }
  const cleanPath = (path || '').toString().replace(/^#\/?/, '').replace(/\/+$/, '').trim();
  const cleanSubKey = Array.isArray(subKey) ? subKey.join('-') : (subKey || '').toString().trim();
  return `admin_page_${cleanPath}${cleanSubKey ? `_${cleanSubKey}` : ''}`;
};

export const getSavedPage = (pathname = '', subKey = '', defaultPage = 0) => {
  try {
    const key = getPaginationKey(pathname, subKey);
    const saved = sessionStorage.getItem(key);
    if (saved !== null && saved !== undefined && saved !== '') {
      const parsed = parseInt(saved, 10);
      return !isNaN(parsed) && parsed >= 0 ? parsed : defaultPage;
    }
  } catch (e) {
    // ignore sessionStorage errors
  }
  return defaultPage;
};

export const setSavedPage = (pathname = '', subKey = '', page = 0) => {
  try {
    const key = getPaginationKey(pathname, subKey);
    const pageNum = parseInt(page, 10);
    const validPage = !isNaN(pageNum) && pageNum >= 0 ? pageNum : 0;
    sessionStorage.setItem(key, String(validPage));
  } catch (e) {
    // ignore sessionStorage errors
  }
};

export const clearSavedPage = (pathname = '', subKey = '') => {
  try {
    const key = getPaginationKey(pathname, subKey);
    sessionStorage.removeItem(key);
  } catch (e) {
    // ignore sessionStorage errors
  }
};

export const clampPage = (page = 0, totalCount = 0, rowsPerPage = 10) => {
  const count = parseInt(totalCount, 10) || 0;
  const perPage = parseInt(rowsPerPage, 10) || 10;
  const maxPage = Math.max(0, Math.ceil(count / perPage) - 1);
  return Math.min(Math.max(0, parseInt(page, 10) || 0), maxPage);
};

export default {
  getPaginationKey,
  getSavedPage,
  setSavedPage,
  clearSavedPage,
  clampPage,
};
